import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'

import { useIsMobile } from 'hooks/useIsMobile'
import { basePath } from 'interfaces/constants'

export const SimilacDefaultBanner = () => {
  const isMobile = useIsMobile()
  return (
    <StyledContainer>
      <div className="onboarding-banner-wrapper">
        <img
          src={
            isMobile
              ? `${basePath}/images/similac-onboarding-default-mobile.png`
              : `${basePath}/images/similac-onboarding-default-desktop.png?v=2`
          }
          alt=""
          style={{
            position: 'relative',
            maxHeight: '100vh',
          }}
          loading="lazy"
        />
        {/* {!isMobile && (
          <div className="onboarding-banner-title">
            <Heading
              tag="h1"
              as={'div' as any}
              style={{
                marginBottom: 24,
              }}
            >
              {f({
                id: 'similac.onboarding.defaultBanner.title',
              })}
            </Heading>
            <Text size="p1">
              {f({
                id: 'similac.onboarding.defaultBanner.subtitle',
              })}
            </Text>
          </div>
        )} */}
      </div>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .onboarding-banner-wrapper {
    position: relative;
    ${MediaQueries.mbDown} {
      width: 100%;
    }
  }
  .onboarding-banner-title {
    position: absolute;
    top: 8%;
    left: 50%;
    transform: translateX(-50%);
    max-width: 87%;
    text-align: center;
  }
`
